namespace HA.Core.HTML {
    //noinspection TsLint
    export class Module extends Div {
        /**
         * @param data
         */
        protected initialize(data: any) {
            super.initialize(data);
            this.addClass("mod");
            this.setActive(true);
            this.setId(HA.Core.Entity.Entity.genId());
            this.loadData();

            if (this.has("upinternal")) {
                const interval = setInterval(() => {
                    this.loadData()
                }, this.get("upinternal"));
                const me = this;
                const [appId, subscriptionId] = getWebPageService().subscribeToAppInfo((info: Map<string, any>) => {
                    if (info.get("s") === -1) {
                        clearInterval(interval);
                        getWebPageService().unsubscribeToAppInfo(subscriptionId);
                        return;

                    }
                    me.setActive(appId === info.get("id"))
                });
            }
        }

        private loadData() {
            if (!this.isActive()) {
                return;
            }
            const me = this;
             getDataRepository().fetchData(this.get("d")).then((response: Map<any, any>) => {
                const app = toMap(response.get("app"));
                if (!app) {
                    return;
                }
                const md = toMap(app.get("mod"));
                const d = toMap(md.get("d"));
                d.set("trans", md.get("trans"));
                if (md.has("class")) {
                    this.addClass(md.get("class"));
                } else if (md.has("classes")) {
                    this.addClasses(md.get("classes"));
                }
              //  log2(me.findElementByAttribute("feedl").scrollLeft)
                me.clear();
                me.appendChild(new Tag(d));
                this.initAnchors(this);
            });
        }

        private initAnchors(tag?: Tag) {
            tag = tag || this.getTag();
            const anchors = tag.fetchByTagName("a");
            anchors.forEach((anchor: Tag) => {
                if (anchor.getAttribute("i")) {
                    return;
                }
                anchor.setAttribute("i", "1");
                const data = new Map();
                data.set("tag", anchor);
                data.set("services", getService4App());
                const a = new Anchor(data);

            });
        }

        protected isActive(): boolean {
            return this.get("isActive");
        }

        protected setActive(active: boolean): void {
            this.addToData("isActive", active);
        }
    }
}
